import moment from "moment";
import { extendMoment } from "moment-range";
import "moment/min/locales";

//trans
import messages_pt from "./pt.json";
import messages_en from "./en.json";

extendMoment(moment);

const messages = {
  pt: messages_pt,
  en: messages_en
};

//based on browser
// language without region code
//const BrowserLanguage = navigator.language.split(/[-_]/)[0];
const BrowserLanguage =
  typeof window !== "undefined" ? navigator.language.split(/[-_]/)[0] : "pt";

function changeLanguage(language) {
  if (typeof window !== "undefined") {
    localStorage.setItem("portalUALang", language);
    window.location.reload();
  }
  //return null;
}

function lang() {
  if (typeof window !== "undefined") {
    if (localStorage.getItem("portalUALang") === null) {
      changeLanguage("pt");
      return "pt";
    }
    return localStorage.getItem("portalUALang");
  }
  // return "pt";
}

if (lang() === "pt") {
  moment.locale("pt");
} else {
  moment.locale("en");
}

export { messages, BrowserLanguage, lang, changeLanguage };
